export default __webpack_public_path__ + "static/media/room-2-theme.e570ae66.webp";